import http from '@/utils/http'
export function file(data) {
    return http.post('/files', data, {
        headers: { 'Content-Type': 'multipart/form-data' },
        unformat: true
    })
}